// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/model.json";

export default Object.assign(
  {},
  part0,
);
